import { MENU_ITEMS } from "../../consts";
import { Breadcrumb } from "antd";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

const AppBreadcrumb = () => {
  const [activeItem, setActiveItem] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const active = MENU_ITEMS.find((item) => item.key === location.pathname);
    setActiveItem(active);
  }, [location.pathname]);

  const capitalizeFirstLetter = (string) => {
    string = string.toLowerCase();
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  return (
    <Breadcrumb
      style={{
        margin: "16px 0",
      }}
    >
      <Breadcrumb.Item>Home</Breadcrumb.Item>
      {activeItem && (
        <Breadcrumb.Item>
          {capitalizeFirstLetter(activeItem.label)}
        </Breadcrumb.Item>
      )}
    </Breadcrumb>
  );
};
export default AppBreadcrumb;
